import * as React from "react"
import { Typography } from "@mui/material"


export default function nameColumn() {
	return {
		name: "label",
		setBodyCellProps: () => ({ sx: { textAlign: 'center'} }),
		render: value => <Typography variant="caption">{value}</Typography>
	}
}